import { useEffect, useState } from 'react';

function getInitials(name) {
  if (!name) return 'U';
  return name
    .split(' ')
    .map((n) => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

/**
 * Avatar circular com fallback para iniciais quando URL ausente ou quebrada.
 */
export function UserAvatar({ src, name, size = 32, className = '' }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const hasPhoto = Boolean(src) && !failed;

  return (
    <div
      className={[
        'grid place-items-center rounded-full shrink-0 overflow-hidden font-700',
        hasPhoto ? 'bg-white dark:bg-slate-800 border border-border' : 'bg-accent text-text-inverse',
        className,
      ].join(' ')}
      style={{ width: size, height: size }}
    >
      {hasPhoto ? (
        <img
          src={src}
          alt=""
          className="w-full h-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        <span className={size >= 40 ? 'text-sm' : 'text-xs'}>{getInitials(name)}</span>
      )}
    </div>
  );
}
